import React, { useState } from 'react'
import { Button, List, NavBar, Switch } from 'antd-mobile'
import { CloseOutline } from 'antd-mobile-icons'
import { useNavigate } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import { deviceRecoil } from '../../../recoils/device'
import { LIKE_BUTTON_STATUS } from '../../../entities/Device'
import { getCookie } from 'react-use-cookie'
import { useTranslation } from 'react-i18next'

const EditDeviceLikeButton = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const organization = getCookie('organization')
  const deviceId = getCookie('deviceId')
  const [device, setDevice] = useRecoilState(deviceRecoil({ organizationId: organization, deviceId }))
  const [likeButtonStatus, setLikeButtonStatus] = useState(device.client.current.likeButtonStatus)

  const handleChangeLikeButton = () => {
    setDevice({
      ...device,
      client: { ...device.client, current: { ...device.client.current, likeButtonStatus } },
    })
    navigate('/device/detail')
  }

  return (
    <div className="container">
      <NavBar
        className="fixed-top"
        style={{ '--border-bottom': '1px solid #EEEEEE', height: '55px' }}
        right={
          <Button fill="none" onClick={() => navigate('/')}>
            <CloseOutline color="#111827" />
          </Button>
        }
        onBack={() => navigate('/device/detail')}
      >
        {t('device.edit.like-status.title')}
      </NavBar>
      <List style={{ '--border-top': 'none', padding: '75px 25px 20px' }}>
        <List.Item
          extra={
            <Switch
              checked={likeButtonStatus === LIKE_BUTTON_STATUS.SHOW}
              onChange={(value) => setLikeButtonStatus(value ? LIKE_BUTTON_STATUS.SHOW : LIKE_BUTTON_STATUS.HIDE)}
            />
          }
        >
          {t('device.edit.like-status.title')}
        </List.Item>
      </List>
      <List style={{ '--border-top': 'none', '--border-bottom': 'none', padding: '20px' }}>
        <List.Item>
          <Button
            color="primary"
            fill="solid"
            style={{ width: '100%', marginTop: '58px' }}
            onClick={handleChangeLikeButton}
          >
            {t('device.edit.like-status.button.save')}
          </Button>
        </List.Item>
      </List>
    </div>
  )
}

export default EditDeviceLikeButton
